import React from 'react';
import { FaEye, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { SITE_DOMAIN } from '../config/host';

/**
 * Franja permanente cuando se está dentro del grupo de demostración.
 *
 * Se dice desde el principio y no al pulsar Guardar: descubrir que nada se
 * guardaba después de escribir una canción entera sería una pérdida de tiempo
 * de quien está evaluando el producto.
 *
 * No es una medida de seguridad. Lo que impide guardar es el backend, que
 * rechaza toda escritura de un grupo demo aunque se llame al API a mano.
 */
const AvisoDemo: React.FC = () => {
  const { isDemo } = useAuth();
  if (!isDemo) return null;

  const web = SITE_DOMAIN ? `https://${SITE_DOMAIN}` : '';

  return (
    <div
      className="alert alert-warning d-flex flex-wrap align-items-center gap-2 mb-3 py-2"
      role="status"
    >
      <FaEye aria-hidden />
      <strong>Estás en el demo.</strong>
      <span>Mira todo lo que quieras: los cambios no se guardan.</span>
      <a
        className="btn btn-sm btn-warning ms-auto d-inline-flex align-items-center gap-2"
        href={web ? `${web}/#solicitar` : 'mailto:ventas@miensamble.com'}
      >
        <FaEnvelope aria-hidden />
        Quiero mi propia cuenta
      </a>
    </div>
  );
};

export default AvisoDemo;
